export default __webpack_public_path__ + "static/media/LetsGetStarted2.84a9b25e.svg";